import { Skeleton } from '@/components/ui/Skeleton';
import styles from './AuctionCard.module.css';

export const AuctionCardSkeleton = () => {
  return (
    <div className={styles.card} style={{ pointerEvents: 'none' }}>
      <div className={styles.coverWrap}>
        <Skeleton width="100%" height="100%" rounded="sm" />
      </div>
      <div className={styles.body}>
        <Skeleton width="60%" height={14} />
        <Skeleton width="90%" height={16} />
        <Skeleton width="40%" height={16} />
        <div style={{ marginTop: 4 }}>
          <Skeleton width="50%" height={12} />
        </div>
      </div>
    </div>
  );
};